<template>
  <div class="bg-primary-purple">
    <div class="mx-auto lg:px-12 px-5 xl:px-20 footer 3xl:px-0 pt-10 pb-16 xl:pt-16 xl:pb-10">
      <div class="relative hidden pb-8 space-x-24 xl:flex">
        <ColumnMa />

        <ColumnCategories />

        <ColumnLearn />

        <ColumnSupport />

        <a
          href="/"
          class="absolute bottom-0 right-0 hidden mb-8 xl:block"
          style="margin-left: auto;"
        >
          <img
            src="https://s3.amazonaws.com/ma-content/images/2024/logo-light.png"
            alt="Motion Array"
            style="width: 137px;"
          >
        </a>
      </div>

      <div class="sm:flex xl:pt-4 xl:border-t xl:border-424242">
        <div class="xl:flex">
          <a
            href="/"
            class="text-white xl:hidden"
          >
            <img
            src="https://s3.amazonaws.com/ma-content/images/2024/logo-light.png"
              alt="Motion Array"
              style="width: 137px;"
            >
          </a>

          <p
            class="mt-5 text-xs xl:mt-0"
            style="color: #f3f3f3; letter-spacing: 0.25px;"
          >
            Copyright ©
            <span class="font-light font-roboto">2013 - {{ new Date().getFullYear() }}</span>
            Artlist Ltd. <wbr> All Rights Reserved.
          </p>

          <div class="mt-3 xl:hidden">
            <a
              href="/privacy-policy"
              class="inline-block text-xs text-white"
            >
              Privacy Policy
            </a>

            <span class="inline-block text-xs text-white">&vert;</span>

            <a
              href="/terms-of-service"
              class="inline-block text-xs text-white"
            >
              Terms of Service
            </a>

            <span class="inline-block text-xs text-white">&vert;</span>

            <a
              href="#"
              class="inline-block text-xs text-white font-raleway"
            >
              <span data-acsb="trigger">Accessibility</span>
            </a>
          </div>

          <p
            class="mt-3 text-xs font-medium xl:mt-0 xl:ml-3"
            style="color: #828282; letter-spacing: 0.25px;"
          >
            Adobe® After Effects® and Premiere Pro® is <br class="xl:hidden">
            a trademark of Adobe Systems Incorporated
          </p>
        </div>

        <div
          class="flex justify-center mt-10 space-x-8 text-white sm:ml-auto xl:mt-0"
        >
          <a
            href="https://www.youtube.com/c/MotionArrayTutorials"
            target="_blank"
            rel="noopener noreferrer"
            @click="tracksocialInteractionEvent('youtube', 'https://www.youtube.com/c/MotionArrayTutorials')"
          >
            <i class="fab fa-youtube fa-lg" />
          </a>

          <a
            href="https://www.facebook.com/motionarray"
            target="_blank"
            rel="noopener noreferrer"
            @click="tracksocialInteractionEvent('facebook', 'https://www.facebook.com/motionarray')"
          >
            <i class="fab fa-facebook fa-lg" />
          </a>

          <a
            href="https://www.instagram.com/motionarray"
            target="_blank"
            rel="noopener noreferrer"
            @click="tracksocialInteractionEvent('instagram', 'https://www.instagram.com/motionarray')"
          >
            <i class="fab fa-instagram fa-lg" />
          </a>

          <a
            href="https://twitter.com/MotionArray"
            target="_blank"
            rel="noopener noreferrer"
            @click="tracksocialInteractionEvent('twitter', 'https://twitter.com/MotionArray')"
          >
            <i class="fab fa-twitter fa-lg" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import analyticsEvents from '@/utils/analyticsEvents';
import { eventTracker } from '@/utils/eventTracker';
import gtmEvents from '@/utils/gtmEvents';
import { dataLayerTrack } from '@/utils/datalayer';
import ColumnMa from './column-ma.vue';
import ColumnCategories from './column-categories.vue';
import ColumnLearn from './column-learn.vue';
import ColumnSupport from './column-support.vue';

export default {
  components: {
    ColumnMa,
    ColumnCategories,
    ColumnLearn,
    ColumnSupport,
  },
  methods: {
    tracksocialInteractionEvent(name, clickUrl) {
      const eventData = {
        sectionId: 'footer',
        name,
        clickUrl,
      };
      eventTracker(analyticsEvents.socialInteraction, eventData);
      dataLayerTrack({ eventName: gtmEvents.socialInteraction, data: eventData });
    },
  },
};
</script>

<style scoped>
.footer {
  max-width: 1720px;
}

::v-deep .footer-link {
  @apply text-xs font-medium text-white text-opacity-75;
  letter-spacing: 0.25px;
}

::v-deep .footer-link:hover {
  @apply text-white;
}

@screen xl {
  .xl\:border-424242 {
    border-color: #424242;
  }
}
</style>
